import AreYouSure from '../../core/AreYouSure';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMore from '@material-ui/icons/ArrowDropDown';
import ExpandLess from '@material-ui/icons/ArrowDropUp';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ENTITLEMENTS } from '../../application-core/constants';
import SlatInner from '../../core/SlatInner';
import { globalStyles as styles } from '../../core/style/gstheme';
import { checkResourceEntitlements } from '../../core/utils/utils';
import CreateConceptDialogContainer from './CreateConceptDialogContainer';
import { DropTarget } from 'react-dnd';
import { STATUS_REJECTED, STATUS_ACCEPTED } from '../../core/utils/constants';

const REJECTED = STATUS_REJECTED;
const APPROVED = STATUS_ACCEPTED;

const Types = {
    CONCEPT: 'concept'
};

function collectTarget(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    };
}

const conceptTarget = {
    canDrop(props, monitor) {
        const item = monitor.getItem();
        if (props.data.id === item.conceptId) return false;
        if (props.titlePath.includes(item.conceptId)) return false;
        return true;
    },
    drop(props, monitor) {
        const item = monitor.getItem();
        // Tell parent component we want to move
        props.checkConcept(item.conceptId);
    }
};

class ConceptSlat extends React.Component {

    state = {
        active: false,
        activeChilden: false,
        areYouSure: false
    };

    onCheckBreakLink = () => {
        this.setState({ areYouSure: true });
    };

    onSure = () => {
        this.setState({ areYouSure: false });
        this.props.onBreakLink(this.props.parent, this.props.childProperty, this.props.data.id);
    };

    onNotSure = () => this.setState({ areYouSure: false });

    setActive = (isActive) => this.setState({ active: isActive });

    activateChildren = () => this.setState({ activeChildren: true });

    deactivateChildren = () => {
        this.setState({ activeChildren: false });
        this.setActive(false);
    };

    render() {

        const { data, onSelect, classes, onAddNewConcept, schemeIRI, childProperty, path, connectDropTarget,
            titleTree, titlePath, viewLang, addToScheme, useXL, useSlashIRI, useUuidIRI, iriOptions,
            onAddExistingConcept, defaultLang, parent, onBreakLink, selectedTitlePath, useWorkflow,
            isExpanded, graph, expandConcept, collapseConcept } = this.props;
        const { areYouSure } = this.state;

        const notInScheme = !data.inScheme || !data.inScheme.includes(schemeIRI);
        const isReadOnly = checkResourceEntitlements(data, [ENTITLEMENTS.EDIT_TAXONOMY])
            || (useWorkflow && "status" in data && (data.status[0] === APPROVED || data.status[0] === REJECTED));
        const resourceCount = data.narrower ? data.narrower.length : 0;

        let label = "No label available";
        const displayLang = viewLang && data.prefLabel && data.prefLabel[viewLang] ?
            viewLang
            :
            defaultLang;
        if (data.prefLabel && data.prefLabel[displayLang]) {
            label = Array.isArray(data.prefLabel[displayLang]) ?
                [...data.prefLabel[displayLang]].sort().join(" AND ")
                :
                data.prefLabel[displayLang];
        }

        const fallbackLang = (viewLang && viewLang !== defaultLang && displayLang === defaultLang)
            || (displayLang === defaultLang && (!data.prefLabel || !data.prefLabel[defaultLang]));

        let title = label;

        if (resourceCount > 0) title += " (" + resourceCount + ")";
        const selected = selectedTitlePath.length === 1 && selectedTitlePath[0] === data.id;

        return (connectDropTarget(
            <div data-test={selected ? "selected-node-outer" : "node-outer"} style={{ minWidth: '250px', maxWidth: '500px' }}>
                <span className={classes.slatIcon}>
                    {resourceCount > 0 ?
                        data.narrower && data.narrower.length >= 5000 ?
                            <Tooltip data-test="check-warning" title="There are too many concepts to expand">
                                <WarningIcon data-test="warning" />
                            </Tooltip>
                            :
                            (isExpanded ?
                                <ExpandLess data-test="collapse" color="primary" onClick={() => collapseConcept(path)} />
                                :
                                <ExpandMore data-test="expand" color="primary" onClick={() => expandConcept(path)} />
                            )
                        :
                        null
                    }
                </span>
                <SlatInner
                    show={!data.pendingDeletion && this.state.active}
                    title={title}
                    workflowStatus={useWorkflow && "status" in data ? data.status[0] : undefined}
                    deprecated={data.deprecated}
                    selected={selected}
                    fallbackLang={fallbackLang}
                    titleTree={titleTree}
                    notInScheme={notInScheme}
                    onClick={() => onSelect(data.id, [...titlePath])}
                    onActivate={() => this.setActive(true)}
                    onDeactivate={() => !this.state.activeChildren && this.setActive(false)}>
                    {!isReadOnly && notInScheme && !data.deprecated &&
                        <Tooltip title="Add to concept scheme"
                            onClick={() => addToScheme(data.id)}>
                            <IconButton data-test="add-to-scheme" className={classes.smallIconButton} style={{ color: 'white' }}>
                                <BubbleChartIcon />
                            </IconButton>
                        </Tooltip>
                    }
                    {!isReadOnly && !notInScheme &&
                        <Tooltip title="Remove (but do not delete) (Alt+click)"
                            onClick={(ev) => {
                                if (ev.altKey) {
                                    onBreakLink(parent, childProperty, data.id);
                                }
                                else {
                                    this.onCheckBreakLink();
                                }
                            }}>
                            <IconButton data-test="break-link" className={classes.smallIconButton} style={{ color: 'white' }}>
                                <LinkOffIcon />
                            </IconButton>
                        </Tooltip>
                    }
                    {!isReadOnly && !notInScheme && !data.deprecated &&
                        <CreateConceptDialogContainer
                            graph={graph}
                            useXL={useXL}
                            useWorkflow={useWorkflow}
                            schemeIRI={schemeIRI}
                            iriOptions={iriOptions}
                            useSlashIRI={useSlashIRI}
                            useUuidIRI={useUuidIRI}
                            parentIRI={data.id}
                            onOpen={this.activateChildren}
                            onClose={this.deactivateChildren}
                            onAddExistingConcept={onAddExistingConcept}
                            onAddNewConcept={onAddNewConcept}
                            titlePath={titlePath}
                            title="Create or add a new child concept" />
                    }
                </SlatInner>
                {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message={[
                    "Confirm unlink this concept.",
                    "This will not delete this concept but simply remove it from the hierarchy at this position."
                ]} />}
            </div>
        ));
    }
}

ConceptSlat.propTypes = {
    schemeIRI: PropTypes.string.isRequired,
    useSlashIRI: PropTypes.bool,
    useUuidIRI: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    useXL: PropTypes.bool,
    useWorkflow: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    version: PropTypes.number,
    selectedTitlePath: PropTypes.array,
    titlePath: PropTypes.array,
    data: PropTypes.object.isRequired,
    expandConcept: PropTypes.func.isRequired,
    checkConcept: PropTypes.func.isRequired,
    collapseConcept: PropTypes.func.isRequired,
    onAddExistingConcept: PropTypes.func.isRequired,
    onAddNewConcept: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    parent: PropTypes.string.isRequired,
    titleTree: PropTypes.array,
    addToScheme: PropTypes.func.isRequired,
    onBreakLink: PropTypes.func.isRequired,
    childProperty: PropTypes.string.isRequired,
    classes: PropTypes.object,
    iriOptions: PropTypes.object
};

export default DropTarget(Types.CONCEPT, conceptTarget, collectTarget)(withRouter(withStyles(styles)(ConceptSlat)));